'use client';

import React from 'react';

import classes from './footer.module.scss';
import FooterTermsButton from '@/components/footer/footer-terms-button';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';

function Footer({ lang }: { lang: Languages }) {
  const dict = useDictionary();

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.wrap}>
          <div className={classes.linkBox}>
            <div className={classes.footerLinks}>
              <FooterTermsButton
                buttonName={
                  lang === 'ko'
                    ? '개인정보처리방침'
                    : lang === 'ja'
                      ? 'プライバシーポリシー'
                      : 'Privacy Policy'
                }
                termsTitleKeys="mypage.privacyTerm"
                termsContentKey="privacy"
              />
              {lang !== 'ko' && (
                <FooterTermsButton
                  buttonName={
                    lang === 'ja' ? '利用規約' : 'Terms and Conditions of Use'
                  }
                  termsTitleKeys="mypage.useTerm"
                  termsContentKey="service"
                />
              )}
              <FooterTermsButton
                buttonName={
                  lang === 'ko'
                    ? '환불 규정'
                    : lang === 'ja'
                      ? '返金ポリシー'
                      : 'Refund Policy'
                }
                termsTitleKeys="mypage.refundTerm"
                termsContentKey="refund"
              />
              {lang === 'ja' && (
                <FooterTermsButton
                  buttonName="特定商取引法に基づく表記"
                  termsTitleKeys="mypage.jaSpecialLaw"
                  termsContentKey="specialLaw"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.wrap}>
        <div className={classes.linkBox}>
          <div className={classes.footerInfo}>
            {lang === 'ko' ? (
              <p>
                대표자 김종익 | 호스팅서비스사업자 주식회사 딜리버드로지스틱스
                <br />
                사업자 등록 번호 617-86-24600
                <br />
                통신판매업신고 2018-부산해운대-0603
                <br />
                대표전화 051-742-7777 | 이메일 store@giftifan.com
                <br />
                부산광역시 해운대구 센텀동로 57, 지하1층 B102호 (우동,
                부산디자인센터)
              </p>
            ) : (
              <p>
                CEO: Kim Jong-ik | Hosting Service Provider: DeliveredLogistics
                Co., Ltd.
                <br />
                Business Registration No.: 617-86-24600
                <br />
                Mail-Order Sales Registration No.: 2018-Busan Haeundae-0603
                <br />
                Tel: 051-742-7777 | Email: store@giftifan.com
                <br />
                Address: B102, Basement 1F, 57 Sentemdong-ro, Haeundae-gu, Busan
                (Busan Design Center)
              </p>
            )}
            <p>© DeliveredLogistics Co., Ltd.</p>
            <p>
              For some products, GIFFINAN is a mail order intermediary and is
              not a party to the mail order sale. For applicable products,
              obligations and responsibilities regarding the product, product
              information, and transaction lie with the seller, so please check
              each product page for specific details.
            </p>
            <p>
              Unauthorized copying, transmission, distribution, crawling,
              scraping, etc. of the contents, UI, etc. of the Giffy Fan site are
              strictly prohibited by relevant laws such as the Copyright Act and
              the Content Industry Promotion Act.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
